type Props = {
  /** null enquanto o status ainda não foi consultado. */
  conectado: boolean | null;
  /** Número do WhatsApp conectado, quando houver. */
  numero: string | null;
  onAbrir: () => void;
};

/**
 * Indicador do WhatsApp do pós-venda, ao lado do status de conexão do
 * servidor. Só é renderizado quando o produto está ativo — para quem não
 * assinou, o ícone seria ruído sem significado.
 *
 * A cor de fundo diferencia conectado de desconectado, mas nunca sozinha:
 * o ícone ganha um traço cortando quando não está conectado, e o
 * `aria-label`/`title` dizem o estado por extenso.
 */
export function IndicadorPosVenda({ conectado, numero, onAbrir }: Props) {
  const estado = conectado === null ? 'apurando' : conectado ? 'conectado' : 'desconectado';
  const descricao =
    estado === 'apurando'
      ? 'Pós-venda: verificando conexão do WhatsApp'
      : estado === 'conectado'
        ? `Pós-venda: WhatsApp conectado${numero ? ` (${numero})` : ''}`
        : 'Pós-venda: WhatsApp desconectado — clique para conectar';

  return (
    <button
      type="button"
      className={`status-posvenda status-posvenda--${estado}`}
      onClick={onAbrir}
      aria-label={descricao}
      title={descricao}
      data-tooltip-id="icon-tip"
    >
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="6" y="2" width="12" height="20" rx="2.5" />
        <path d="M11 18h2" />
        {estado !== 'conectado' && <path d="M4 3l16 18" />}
      </svg>
    </button>
  );
}
